import { render, staticRenderFns } from "./AddUserGroupModal.vue?vue&type=template&id=321e9f2c"
import script from "./AddUserGroupModal.vue?vue&type=script&lang=js"
export * from "./AddUserGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports